import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["error", "className", "name", "title", "caption", "required", "setValue"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import dayjs from "@/lib/day";
import formStyles from "@/styles/Form.module.scss";
import paymentMethodStyles from "@/styles/PaymentMethod.module.scss";
import classnames from "classnames";
import merge from "deepmerge";
import { forwardRef, useCallback, useEffect, useReducer } from "react";
import SelectField from "./SelectField";
import ErrorMessage from "./ErrorMessage";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function createOption(value, format) {
  const valueWithZero = value < 10 ? "0" + value : String(value);
  return {
    value: valueWithZero,
    label: `${value}${format}`
  };
}
function yearOptions() {
  const now = dayjs();
  const year = now.year();
  const maxYear = year + 15;
  const options = [];
  for (let i of Array(maxYear - year + 1).keys()) {
    const value = year + i;
    options.push(createOption(value, "年"));
  }
  return options;
}
function monthOptions() {
  const options = [];
  for (let i of Array(12).keys()) {
    const value = i + 1;
    options.push(createOption(value, "月"));
  }
  return options;
}
const initialState = {
  expirationDate: "",
  year: "",
  month: ""
};
const ExpirationDateField = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      error,
      className,
      name,
      title,
      caption,
      required,
      setValue
    } = props,
    _props = _objectWithoutProperties(props, _excluded);
  const customStylesMonth = {
    container: provided => _objectSpread(_objectSpread({}, provided), {}, {
      width: "5em"
    }),
    input: provided => _objectSpread(_objectSpread({}, provided), {}, {
      margin: "0",
      paddingBottom: "0px",
      paddingTop: "0px",
      color: "#666",
      width: "3em"
    })
  };
  const customStylesYear = {
    container: provided => _objectSpread(_objectSpread({}, provided), {}, {
      width: "6.8em"
    })
  };
  const reducer = useCallback((state, action) => {
    const newState = _objectSpread({}, state);
    switch (action.type) {
      case "year":
        return merge(newState, {
          year: action.value,
          expirationDate: `${action.value}${state.month}`
        });
      case "month":
        return merge(newState, {
          month: action.value,
          expirationDate: `${state.year}${action.value}`
        });
      default:
        return state;
    }
  }, []);
  const {
    0: state,
    1: dispatch
  } = useReducer(reducer, initialState);
  const handleYearChange = useCallback(option => {
    dispatch({
      type: "year",
      value: option.value
    });
  }, []);
  const handleMonthChange = useCallback(option => {
    dispatch({
      type: "month",
      value: option.value
    });
  }, []);
  const handleBlur = useCallback(() => {
    const input = document.querySelector(`input[name=${name}]`);
    input.dispatchEvent(new Event("blur"));
  }, []);
  useEffect(() => {
    setValue(name, state.expirationDate);
    if (state.expirationDate.length > 0) {
      const input = document.querySelector(`input[name=${name}]`);
      input.dispatchEvent(new Event("input", {
        bubbles: true
      }));
    }
  }, [state.expirationDate]);
  return /*#__PURE__*/_jsxs("div", {
    className: formStyles.inputField,
    children: [title && /*#__PURE__*/_jsx("legend", {
      className: classnames(formStyles.formTitle, {
        [formStyles.required]: required
      }),
      children: title
    }), /*#__PURE__*/_jsxs("div", {
      className: paymentMethodStyles.expirationDateFieldPair,
      children: [/*#__PURE__*/_jsx(SelectField, _objectSpread({
        name: `${name}-m`,
        placeholder: "\u6708",
        options: monthOptions(),
        onChange: handleMonthChange,
        onBlur: handleBlur,
        customStyles: customStylesMonth,
        className: formStyles.selectMonth
      }, _props)), /*#__PURE__*/_jsx(SelectField, _objectSpread({
        name: `${name}-y`,
        placeholder: "\u5E74",
        options: yearOptions(),
        onChange: handleYearChange,
        onBlur: handleBlur,
        customStyles: customStylesYear
      }, _props))]
    }), /*#__PURE__*/_jsx("input", {
      type: "hidden",
      ref: ref,
      name: name,
      value: state.expirationDate
    }), error && /*#__PURE__*/_jsx(ErrorMessage, {
      msg: error
    }), caption && /*#__PURE__*/_jsx("p", {
      className: formStyles.caption,
      children: caption
    })]
  });
});
ExpirationDateField.displayName = "ExpirationDateField";
export default ExpirationDateField;